// No source read shows the vaults under the stone bridges over the burgwallen: the painting draws
// their decks from above. An odd number of equal vaults, none wider than this, on piers this
// thick is an estimate, which leaves the middle of the water open to a boat.
const MAX_VAULT_M = 8;
const PIER_M = 1.2;

export interface EstimatedVaults {
  readonly span: number;
  readonly pierWidth: number;
  /** Where each vault crowns, in metres from the first springing. */
  readonly crownsAt: readonly number[];
}

/** Equal vaults across `wet` metres of water between two abutments. */
export function estimatedVaults(wet: number): EstimatedVaults {
  const fitted = Math.ceil((wet + PIER_M) / (MAX_VAULT_M + PIER_M));
  const count = fitted % 2 === 1 ? fitted : fitted + 1;
  const span = (wet - (count - 1) * PIER_M) / count;
  return {
    span,
    pierWidth: PIER_M,
    crownsAt: Array.from({ length: count }, (_, i) => i * (span + PIER_M) + span / 2),
  };
}
